import { useQuery } from '@tanstack/vue-query'
import { profileKeys } from '../profileQueryKeys'
import { getSellerProfile } from '../profileEndpoints'
import { parseSellerProfile } from '../parsers/profileParser'

// Profile changes rarely within a session, so hold it long.
const PROFILE_STALE_MS = 1000 * 60 * 60

export function useSellerProfileQuery() {
  return useQuery({
    queryKey: profileKeys.me(),
    queryFn: () => getSellerProfile().then(parseSellerProfile),
    staleTime: PROFILE_STALE_MS,
  })
}
